export enum UserType {
    USER = "USER",
    ADMIN = "ADMIN",
    COMPANY = "COMPANY",
    AGENCY = "AGENCY",
}
